import { THEME_PRESETS, detectActivePreset } from "../../lib/themePresets";

/**
 * Horizontal row of preset cards. Clicking a card **prefills** the
 * accent color, letterbox treatment, and PDF accent — values the admin
 * can still edit manually below. The card matching the current form
 * state (or `form.theme`) is highlighted.
 */
export default function ThemePresetPicker({ form, onApply }) {
  const activeId = detectActivePreset(form);
  return (
    <div>
      <div className="text-xs text-zinc-700 mb-1.5">Theme preset</div>
      <div className="text-[11px] text-zinc-500 mb-2 leading-relaxed">
        Curated palettes tuned for real-estate presentations. Click one to
        prefill the accent colour, letterbox fill, and PDF accent — you can
        still tweak the individual values below.
      </div>
      <div
        className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1"
        data-testid="theme-preset-row"
      >
        {THEME_PRESETS.map((p) => {
          const active = p.id === activeId;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onApply(p.id)}
              data-testid={`theme-preset-${p.id}`}
              className={`shrink-0 w-40 text-left rounded-lg border px-3 py-2.5 transition
                ${active
                  ? "border-zinc-900 ring-2 ring-zinc-900/10 bg-zinc-50"
                  : "border-zinc-200 hover:border-zinc-400 bg-white"}`}
            >
              <div className="flex items-center gap-1 mb-2">
                {p.swatch.map((c, i) => (
                  <span
                    key={i}
                    className="h-5 w-5 rounded-full border border-black/10"
                    style={{ background: c }}
                  />
                ))}
              </div>
              <div className="text-sm font-medium text-zinc-900 truncate">
                {p.name}
              </div>
              <div className="text-[11px] text-zinc-500 mt-0.5 leading-tight line-clamp-2">
                {p.description}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
